import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Register plugins on the client only. ScrollTrigger touches window/document,
// so we guard against server-side execution.
if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
}

export { gsap, ScrollTrigger }
